import { GetterTree } from "vuex";
import { isIos } from "@/utils/lodash";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { truncateSync } from "fs";
import deepClone from "@/utils/deepCloneUtil";
import weightRand from "@/utils/weightRand";
import { type } from "os";

const Getters: GetterTree<any, any> = {
  [types.GETTER_SETTING_DATA](state, getters, rootState) {
    return state.settingData;
  },
  [types.GETTER_IS_HAPPY_HOUR](state, getters, rootState) {
    const { coin_limit_sale } = state.settingData;
    return coin_limit_sale && coin_limit_sale.is_happy_hour ? true : false;
  },
  [types.GETTER_DOUBLE_COINS_PERCENTAGE](state, getters, rootState) {
    const { coin_limit_sale } = state.settingData;
    return coin_limit_sale && coin_limit_sale.percentage
      ? coin_limit_sale.percentage
      : 200;
  },

  [types.GETTER_JUDGE_INTERFACE_EXIST](state, getters, rootState) {
    return state.judgeInterFaceExist;
  },
  [types.GETTER_SEARCH_LITE_MODE](state) {
    //判断是否是lite_mode模式：
    // const { settingData } = state;
    // const { enable } = settingData;
    // return enable ? (enable.lite_mode ? true : false) : true;
    return true;
    //TODO默认没有就是true
  },
  [types.GETTER_VIP_TOTAL_COUNT](state) {
    return state.settingData.vip_p_total_count
      ? state.settingData.vip_p_total_count
      : 4;
  },
  [types.GETTER_LOCALIZE_PRICE](state) {
    return (productId: any) => {
      for (const key in state.localizePrice) {
        if (key === productId) {
          return state.localizePrice[key];
        }
      }
      return null;
    };
  },
  [types.GETTER_LOCALIZE_PRICE_DATA](state) {
    return state.localizePrice;
  },

  [types.GETTER_SETTING_BOUGHT_VIP](state) {
    return state.gxUserInfo.services.find((item: any) => item.kind === "vip");
  },

  [types.GETTER_SERVICE_OFFER](state) {
    return (
      state.settingData &&
      state.settingData.hasOwnProperty("service_offers") &&
      state.settingData.service_offers
    );
  },
  [types.GETTER_SPECIAL_COINS](state) {
    return (payLoad: string) => {
      const coinsObj =
        state.settingData && payLoad === "double"
          ? state.settingData.coin_limit_sale
          : state.settingData.coin_half_sale;
      const coinsList = state.settingData && state.settingData.coin_offers;
      // const specialList = coinsObj && coinsObj.best_offer ? coinsObj.best_offer : []
      let specialList: any = [];
      if (coinsObj && coinsObj.best_offer && coinsObj.best_offer.length > 0) {
        specialList = coinsObj.best_offer;
      }
      const result = coinsList.filter((v: any) => {
        return specialList.some((item: any) => {
          return item === v.offer_id;
        });
      });
      return result.length === 0 ? coinsList.slice(0, 3) : result;
    };
  },
  [types.GETTER_SUBS_SETTING](state) {
    return state.subsSetting;
  },
  [types.GETTER_PRODUCTID_VALID](state) {
    return (payLoad: string) => {
      const localizePrice = state.localizePrice;
      return isIos()
        ? !localizePrice || localizePrice.hasOwnProperty(payLoad)
        : true;
    };
  },
  [types.GETTER_APP_TAKE_DOWN](state) {
    return (
      state.settingData &&
      state.settingData.enable &&
      state.settingData.enable.app_takedown
    );
  },
  [types.GETTER_TAKE_DOWN_OPERATE_NUMS](state) {
    return state.takeDownOperateNums;
  },
  [types.GETTER_SPECIAL_OFFER_CONTROL](state) {
    return (payLoad: string) => {
      const control =
        state.settingData && state.settingData.control_special_offer;
      if (!control) {
        return undefined;
      }
      if (payLoad === "follow") {
        return control.special_follow;
      } else if (payLoad === "like") {
        return control.special_like;
      }
      return undefined;
    };
  },
  [types.GETTER_PRO_EXTRA_PERCENTAGE](state) {
    return state.settingData
      ? state.settingData.pro_extra_percentage
        ? state.settingData.pro_extra_percentage
        : 10
      : 10;
  },
  [types.GETTER_VIP_OFFERS](state) {
    return (
      state.settingData &&
      state.settingData.service_offers &&
      state.settingData.service_offers
        .filter((offer: any) => {
          return offer.kind === "vip";
        })
        .reverse()
    );
  },
  [types.GETTER_SETTING_FREE_FOLLOWERS_ENABLE](state) {
    return (
      state.settingData && state.settingData.free_followers_for_newbie_enabled
    );
  },
  [types.GETTER_UNINSTALLED_APP](state) {
    return state.unInstalledList;
  },
  [types.GETTER_BIG_PRICE_LIST](state) {
    return state.settingData && state.settingData.big_prices;
  },
  //-------------------------- back up --------------------------
  [types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID](state) {
    //判断是否有对应的字段
    return state.settingData && state.settingData.back_up;
  },
  [types.GETTER_BACK_UP_APP_PARAMS](state) {
    return state.settingData.back_up;
  },
  [types.GETTER_BACK_UP_APP_DESC](state) {
    return (color: string = "rgb(255,225,49)") => {
      if (state.settingData && state.settingData.back_up) {
        if (state.settingData.back_up.description.desc_highlight) {
          let newDesc = state.settingData.back_up.description.desc;
          for (const key of state.settingData.back_up.description
            .desc_highlight) {
            console.log("key:", key);
            if (newDesc.indexOf(key) > -1) {
              //插入<span></span>
              newDesc = newDesc.replace(
                eval("/" + key + "/"),
                `<span style="color:${color};font-family:'WorkSans-Medium'">${key}</span>`
              );
            }
          }
          console.log("newDesc:", newDesc);
          return newDesc;
        } else {
          return state.settingData.back_up.description.desc;
        }
      } else {
        return ``;
      }
    };
  },
  [types.GETTER_BACK_UP_APP_LAUNCH_DESC](state) {
    if (state.settingData && state.settingData.back_up) {
      if (state.settingData.back_up.description.launch_desc_highlight) {
        let newDesc = state.settingData.back_up.description.launch_desc;
        for (const key of state.settingData.back_up.description
          .launch_desc_highlight) {
          console.log("key:", key);
          if (newDesc.indexOf(key) > -1) {
            //插入<span></span>
            newDesc = newDesc.replace(
              eval("/" + key + "/"),
              `<span style="color:rgb(255,225,49);font-family:'WorkSans-Medium'">${key}</span>`
            );
          }
        }
        console.log("newDesc:", newDesc);
        return newDesc;
      } else {
        return state.settingData.back_up.description.launch_desc;
      }
    } else {
      return ``;
    }
  },
  //--------------------------- super pay -----------------------
  [types.GETTER_SUPER_PAY_SETTING_PARAMS_VALID](state) {
    //判断是否有对应的字段
    return state.settingData && state.settingData.super_pay;
  },
  [types.GETTER_SUPER_PAY_PARAMS](state) {
    return state.settingData.super_pay;
  },
  [types.GETTER_SUPER_PAY_DESC](state) {
    return (color: string = "rgb(255,225,49)") => {
      if (state.settingData && state.settingData.super_pay) {
        if (state.settingData.super_pay.description.desc_highlight) {
          let newDesc = state.settingData.super_pay.description.desc;
          for (const key of state.settingData.super_pay.description
            .desc_highlight) {
            console.log("key:", key);
            if (newDesc.indexOf(key) > -1) {
              //插入<span></span>
              newDesc = newDesc.replace(
                eval("/" + key + "/"),
                `<span style="color:${color};font-family:'WorkSans-Medium'">${key}</span>`
              );
            }
          }
          console.log("newDesc:", newDesc);
          return newDesc;
        } else {
          return state.settingData.super_pay.description.desc;
        }
      } else {
        return ``;
      }
    };
  },
  [types.GETTER_SUPER_PAY_LAUNCH_DESC](state) {
    if (state.settingData && state.settingData.super_pay) {
      if (state.settingData.super_pay.description.launch_desc_highlight) {
        let newDesc = state.settingData.super_pay.description.launch_desc;
        for (const key of state.settingData.super_pay.description
          .launch_desc_highlight) {
          console.log("key:", key);
          if (newDesc.indexOf(key) > -1) {
            //插入<span></span>
            newDesc = newDesc.replace(
              eval("/" + key + "/"),
              `<span style="color:rgb(255,225,49);font-family:'WorkSans-Medium'">${key}</span>`
            );
          }
        }
        console.log("newDesc:", newDesc);
        return newDesc;
      } else {
        return state.settingData.super_pay.description.launch_desc;
      }
    } else {
      return ``;
    }
  },
  // 获取类型为feed_offer以及follow的数组项
  [types.GETTER_RECOMMEND_OFFER](state) {
    const allOffers: any =
      state.settingData && state.settingData.recommend_offers;
    let result: any = [];
    if (allOffers) {
      result = allOffers.filter(
        (v: any) => v.kind === "follow" || v.kind === "feed_coin"
      );
    }
    return result;
  },

  // 根据feed_offer项目的权重获取具体的某一项
  [types.GETTER_CURRENT_OFFER](state, getters) {
    const recommendList = getters[types.GETTER_RECOMMEND_OFFER];
    const resultList = deepClone(recommendList);
    resultList.forEach((v: any) => {
      v.weight =
        v.green_light && v.green_light.weight ? v.green_light.weight : 0;
    });
    return weightRand(resultList);
  },

  [types.GETTER_STATE_FRONT](state, getters) {
    return state.front;
  },

  [types.GETTER_FEATURES_ITEM_BY_FUNCTION](state, getters) {
    return (payload: any) => {
      console.log("payload", payload);
      const featuresList = state.settingData.features;
      const findway = (name: any) => {
        if (featuresList && featuresList.length > 0) {
          const feature = featuresList.find((v: any) => v.function === name);
          return feature ? feature : {};
        } else {
          return {};
        }
      };
      console.log("payload.kind === 'vip'", payload.kind === "vip");
      if (payload.kind === "vip") {
        const result = findway("vip_way");
        return { paypal: result, stripe: {} };
      } else {
        const big_prices: any = getters[types.GETTER_BIG_PRICE_LIST];
        const offer_iap_price = payload && payload.iap && payload.iap.price;
        if (big_prices && big_prices.some((v: any) => v === offer_iap_price)) {
          return {
            paypal: findway("big_pp_way"),
            stripe: findway("big_card_way")
          };
        } else {
          return {
            paypal: findway("small_pp_way"),
            stripe: findway("small_card_way")
          };
        }
      }
    };
  },
  [types.GETTER_PAYPAL_PRICE_DESC](state) {
    return (price: string) => {
      const paypal_price_description =
        state.settingData && state.settingData.paypal_price_description;
      if (!paypal_price_description) {
        return null;
      }
      const key = Object.keys(paypal_price_description).find(
        item => item === price
      );
      console.log("GETTER_PAYPAL_PRICE_DESC key", key);
      return key && paypal_price_description[key];
    };
  }
};

export default Getters;
